import React from 'react';


// --- ICONS ---
const IconX = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;


/**
* Modal Component
* A generic, reusable modal for displaying content in a pop-up window.
*
* @param {object} props - The component props.
* @param {string} props.title - The title to display in the modal header.
* @param {function} props.onClose - The function to call when the modal should be closed.
* @param {React.ReactNode} props.children - The content to display within the modal body.
*/
const Modal = ({ title, onClose, children }) => {
 return (
   <div
     className="fixed inset-0 bg-black/60 z-50 overflow-y-auto animate-fade-in"
     onClick={onClose} // Close modal when clicking on the backdrop
   >
     <div className="min-h-screen px-4 py-8 flex items-end justify-center sm:items-center sm:p-0">
       <div
         className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto animate-fade-in-up"
         onClick={e => e.stopPropagation()} // Prevent clicks inside the modal from closing it
       >
         <div className="flex justify-between items-start mb-4">
           <h3 className="text-2xl font-bold text-gray-900 dark:text-gray-100">{title}</h3>
           <button
             onClick={onClose}
             className="text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 flex-shrink-0"
             aria-label="Close modal"
           >
             <IconX />
           </button>
         </div>
         <div className="overflow-y-auto">
           {children}
         </div>
       </div>
     </div>
     <style>{`
       .animate-fade-in { animation: fadeIn 0.3s ease-out; }
       @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
       .animate-fade-in-up { animation: fadeInUp 0.3s ease-out; }
       @keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
     `}</style>
   </div>
 );
};


export default Modal;